<template>
  <div class="mobile-bottom-menu d-md-none">
    <a 
      v-for="(item, index) in items" 
      :key="index" 
      :href="item.url" 
      class="menu-item"
      :class="{ active: item.active }"
    >
      <div class="icon" v-html="item.icon"></div>
      <span class="label">{{ item.label }}</span>
    </a>
  </div>
</template>

<script>
export default {
  name: 'MobileBottomMenu',
  props: {
    items: {
      type: Array, // Array of objects: { label, url, icon (svg string), active (bool) }
      required: true
    }
  }
}
</script>

<style scoped>
.mobile-bottom-menu {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 10px 5px 15px 5px; /* Extra padding at bottom for safe area on iOS */
  box-shadow: 0 -4px 20px rgba(0,0,0,0.05);
  z-index: 1040; /* Above bootstrap modal backdrop if needed, or similar to fixed header */
  border-top: 1px solid #ebeaed;
}

.menu-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #013D82; /* Primary color from theme */
  font-size: 11px;
  font-weight: 500;
  text-decoration: none;
  padding: 6px;
  border-radius: 8px;
  width: 65px;
  transition: all 0.3s ease;
}

.menu-item:hover {
    color: #013D82;
    background-color: rgba(1, 61, 130, 0.05);
}

.menu-item .icon {
  width: 20px;
  height: 20px;
  margin-bottom: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Deep selector to target the injected SVG */
.menu-item .icon :deep(svg) {
  width: 20px;
  height: 20px;
  stroke: currentColor;
  stroke-width: 2;
}

.menu-item.active {
  background-color: rgba(1, 61, 130, 0.1);
  color: #013D82;
  font-weight: 700;
}

.menu-item.active .icon :deep(svg) {
    stroke: #013D82;
}
</style>
